(function () {
  if (window.BlagowoodExploreDeitiesLoaded) return;
  window.BlagowoodExploreDeitiesLoaded = true;

  const splitValues = (value) => {
    const source = String(value || '').trim();
    if (!source) return [];

    if (source.startsWith('[') && source.endsWith(']')) {
      try {
        const parsed = JSON.parse(source);
        if (Array.isArray(parsed)) return parsed.map((item) => String(item).trim()).filter(Boolean);
      } catch (error) {
        // Fall through to the delimiter parser for malformed legacy values.
      }
    }

    return source
      .split(/\|\||\n|;|,/)
      .map((item) => item.trim().replace(/^\[|\]$/g, '').replace(/^["']|["']$/g, ''))
      .filter(Boolean);
  };

  const normalize = (value) => value.trim().toLocaleLowerCase();

  class ExploreDeities extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.activeFilters = {};
      this.cards = Array.from(this.querySelectorAll('[data-deity-card]'));
      this.emptyState = this.querySelector('[data-empty-state]');
      if (window.Shopify && window.Shopify.designMode) {
        const accordion = this.querySelector('[data-explore-deities-accordion]');
        if (accordion) accordion.open = true;
      }
      this.buildMenus();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.applyFilters();
    }

    buildMenus() {
      this.querySelectorAll('[data-filter-menu]').forEach((menu) => {
        const key = menu.dataset.filterMenu;
        const values = new Map();
        this.cards.forEach((card) => {
          splitValues(card.dataset[key]).forEach((value) => values.set(normalize(value), value));
        });
        Array.from(values.entries())
          .sort((a, b) => a[1].localeCompare(b[1]))
          .forEach(([normalized, label]) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'explore-deities__filter-option';
            button.dataset.filterOption = key;
            button.dataset.filterValue = normalized;
            button.textContent = label;
            button.setAttribute('role', 'option');
            button.setAttribute('aria-selected', 'false');
            menu.appendChild(button);
          });

        const wrapper = menu.closest('[data-filter]');
        if (!values.size && wrapper) wrapper.hidden = true;
      });
    }

    onClick(event) {
      const reset = event.target.closest('[data-filter-reset]');
      if (reset) {
        this.activeFilters = {};
        this.querySelectorAll('[data-filter-option]').forEach((option) => {
          option.classList.remove('is-selected');
          option.setAttribute('aria-selected', 'false');
        });
        this.updateTriggers();
        this.closeMenus();
        this.applyFilters();
        return;
      }

      const trigger = event.target.closest('[data-filter-trigger]');
      if (trigger) {
        const menu = this.querySelector('#' + CSS.escape(trigger.getAttribute('aria-controls')));
        const willOpen = menu && menu.hidden;
        this.closeMenus();
        if (menu && willOpen) {
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      const option = event.target.closest('[data-filter-option]');
      if (option) {
        const key = option.dataset.filterOption;
        const value = option.dataset.filterValue;
        this.activeFilters[key] = this.activeFilters[key] === value ? null : value;
        this.querySelectorAll(`[data-filter-option="${key}"]`).forEach((item) => {
          const selected = this.activeFilters[key] === item.dataset.filterValue;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        this.updateTriggers();
        this.closeMenus();
        this.applyFilters();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        const trigger = this.querySelector('[data-filter-trigger][aria-expanded="true"]');
        this.closeMenus();
        if (trigger) trigger.focus();
      }
    }

    updateTriggers() {
      let hasActive = false;
      this.querySelectorAll('[data-filter-trigger]').forEach((trigger) => {
        const key = trigger.dataset.filterTrigger;
        const active = Boolean(this.activeFilters[key]);
        trigger.classList.toggle('is-active', active);
        hasActive = hasActive || active;
      });
      const reset = this.querySelector('[data-filter-reset]');
      if (reset) reset.classList.toggle('is-active', !hasActive);
    }

    closeMenus() {
      this.querySelectorAll('[data-filter-menu]').forEach((menu) => { menu.hidden = true; });
      this.querySelectorAll('[data-filter-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    }

    applyFilters() {
      let visibleCount = 0;
      const counts = { available: 0, coming: 0 };
      this.cards.forEach((card) => {
        const visible = Object.entries(this.activeFilters).every(([key, selected]) => {
          if (!selected) return true;
          return splitValues(card.dataset[key]).some((value) => normalize(value) === selected);
        });
        card.hidden = !visible;
        if (visible) {
          visibleCount += 1;
          counts[card.dataset.status] += 1;
        }
      });

      this.querySelectorAll('[data-status-group]').forEach((group) => {
        const status = group.dataset.statusGroup;
        group.hidden = counts[status] === 0;
      });
      if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
    }
  }

  if (!customElements.get('explore-deities')) customElements.define('explore-deities', ExploreDeities);

  document.addEventListener('toggle', (event) => {
    if (window.Shopify && window.Shopify.designMode) return;
    const opened = event.target;
    if (!opened.matches || !opened.matches('[data-explore-deities-accordion]') || !opened.open) return;
    document.querySelectorAll('[data-explore-deities-accordion][open]').forEach((details) => {
      if (details !== opened) details.open = false;
    });
  }, true);

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('explore-deities');
    const accordion = section && section.querySelector('[data-explore-deities-accordion]');
    if (accordion) accordion.open = true;
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('explore-deities').forEach((section) => {
      if (!section.contains(event.target)) section.closeMenus();
    });
  });
})();
